var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeneficios2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.104,
    height: 64.525,
    viewBox: "0 0 44.104 64.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f5f5f5;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Beneficios_white",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-1",
    d: "M34.973,50.255a30.5,30.5,0,0,0-5.033-1.281c1.177-1.382,2.431-2.915,3.691-4.553C40.581,35.387,44.1,27.859,44.1,22.053a22.052,22.052,0,1,0-44.1,0c0,5.84,3.524,13.376,10.474,22.4,1.254,1.629,2.5,3.151,3.675,4.526a30.51,30.51,0,0,0-5.017,1.279c-5.243,1.874-6.344,4.388-6.344,6.171s1.1,4.3,6.344,6.17a39.812,39.812,0,0,0,12.92,1.929A39.812,39.812,0,0,0,34.973,62.6c5.243-1.873,6.344-4.388,6.344-6.17S40.217,52.128,34.973,50.255ZM3.781,22.052a18.272,18.272,0,0,1,36.543,0c0,4.877-3.341,11.8-9.662,20.027a123.3,123.3,0,0,1-8.613,9.979,122.3,122.3,0,0,1-8.581-9.915C7.131,33.916,3.781,26.971,3.781,22.052ZM33.7,59.035a36.013,36.013,0,0,1-11.651,1.709A36,36,0,0,1,10.4,59.035c-2.789-1-3.834-2.124-3.834-2.609s1.045-1.612,3.834-2.612a30.162,30.162,0,0,1,6.747-1.447C19.2,54.609,20.623,56,20.733,56.11l1.323,1.29,1.319-1.29c.11-.107,1.524-1.5,3.571-3.742A30.169,30.169,0,0,1,33.7,53.815c2.793,1,3.834,2.131,3.834,2.611S36.5,58.038,33.7,59.035Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-1",
    d: "M113.431,94.119a1.514,1.514,0,0,0-2.877.928,9.387,9.387,0,1,1-6.4-6.156,1.514,1.514,0,1,0,.813-2.918,12.416,12.416,0,1,0,8.479,8.146Z",
    transform: "translate(-79.538 -75.413)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-1",
    d: "M213.981,107.4l-.014-.014a1.514,1.514,0,0,0-2.135,2.141l.014.014a1.514,1.514,0,1,0,2.141-2.141Z",
    transform: "translate(-184.448 -93.294)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneficios2);
export default __webpack_public_path__ + "static/media/Beneficios2.19895387b248b630e28af953877bc79b.svg";
export { ForwardRef as ReactComponent };